export const SEGMENTED_CONTROL = {
    containerPadding: 4,
    segmentHeight: 48,
    animationDuration: 200,
    dragActivationOffset: 10,
} as const;
